import { gql } from "@apollo/client";

export const ADD_STUDENT_ENROLLMENT = gql`
  mutation AddStudentEnrollment($input: AddEnrollmentInput!) {
    addStudentEnrollment(input: $input) {
      message
      studentName
      className
      programmeName
      startSchoolDate
      enrollmentAt
      remark
      enrollmentBy
      status
    }
  }
`;


export const REMARK_STUDENT_TRANSFER_AND_PAID_BUT_NOT_COUNT = gql`
  mutation RemarkStudentTransferOutAndPaidButNotCountInEnrollFee($enrollmentId: ID!, $input: PaidButNotCountInEnrollFeeInfoInput) {
    remarkStudentTransferOutAndPaidButNotCountInEnrollFee(enrollmentId: $enrollmentId, input: $input) {
      status
      message
    }
  }
`


export const CHECK_IS_TRANSFER_OUT_AND_PAID = gql`
  query Query($enrollmentId: ID!) {
    isTranferOutAndPaid(enrollmentId: $enrollmentId)
  }
`;


export const GET_ENROLLMENT_BY_STUDENT = gql`
  query GetEnrollmentsByStudentPagination(
    $page: Int!
    $studentId: ID!
    $academicYearId: ID!
    $limit: Int
    $enrollType: String
  ) {
    getEnrollmentsByStudentPagination(
      page: $page
      studentId: $studentId
      academicYearId: $academicYearId
      limit: $limit
      enrollType: $enrollType
    ) {
      data {
        _id
        academicYearId
        academicYearName
        programmeId
        programmeName
        customerType
        shiftName
        classId
        className
        gradeId
        gradeName
        classRoomName
        startSchoolDate
        enrollmentAt
        remark
        isDropOut
        isReEnroll
        isSuspended
        isSubspend
        isSchoolAge
        isOldStudent
        isAddProgramme
        isTransferIn
        transferInFromId {
          _id
          title
          remark
        }
        isTransferOut
        isAllowInClass
        joinClassDate
        isChangeClass
        changeClass {
          changeFromEnrollId {
            _id
            className
          }
          changeToEnrollId {
            _id
            className
          }
          changeInDate
          changeOutDate
        }
        transfer {
          atAcademicYearName
          writeForm
          leavingAt
          reason
          reasonComment
          transferType
          transferTo {
            _id
            title
            remark
          }
          getDocAt
          doctoAdmin
          docToParent
          atAcademicYear
        }
      }
      paginator {
        slNo
        prev
        next
        perPage
        totalPosts
        totalPages
        currentPage
        hasPrevPage
        hasNextPage
        totalDocs
      }
    }
  }
`;

export const UPDATE_STUDENT_ENROLLMENT = gql`
  mutation UpdateStudentEnrollment($id: ID!, $input: AddEnrollmentInput!) {
    updateStudentEnrollment(_id: $id, input: $input) {
      status
      message
    }
  }
`;

export const DELETE_STUDENT_ENROLLMENT = gql`
  mutation DeleteStudentEnrollment($id: ID!) {
    deleteStudentEnrollment(_id: $id) { 
      status
      message
    }
  }
`;



export const CREATE_REQUEST_TRANSACTION = gql`
mutation CreateRequestTransaction($input: RequestTransactionInput) {
  createRequestTransaction(input: $input) {
    status
    message
  }
}
`;

export const UPDATE_REQUEST_TRANSACTION = gql`
mutation UpdateRequestTransaction($id: ID!, $input: RequestTransactionInput) {
  updateRequestTransaction(_id: $id, input: $input) {
    status
    message
  }
}
`;


export const GET_REQUEST_TRANSACTION_BY_ENROLLMENT_ID = gql`
query GetRequestTransactionByEnrollmentId($enrollmentId: ID, $isChecked: String) {
  getRequestTransactionByEnrollmentId(enrollmentId: $enrollmentId, isChecked: $isChecked) {
     _id
    isChecked
    teacherStatus
    financeStatus 
    enrollmentId
    financeRemark
    programId
    remark
    requestAt
    requestedBy
    requestType
    requestTransactionStatus
    studentId {
      _id
      englishName
      firstName
      profileImg
      lastName
    }
  }
}
`;


export const GET_REQUEST_TRANSACTION = gql`
query GetRequestTransaction($type: String) {
  getRequestTransaction(type: $type) {
    _id
    requestAt
    requestedBy
    enrollmentId
    isChecked
    requestType
    teacherStatus
    financeStatus
    studentId {
      _id
      firstName
      lastName
      profileImg
    }
    requestTransactionStatus
    remark
    programId
    financeRemark
    classId {
      _id
      className
      gradeId {
        _id
        gradeName
      }
    }
  }
}
`;